import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";
import {TreasurePieceConfig} from "@/modules/redactor/models/smart-offer/bundle-treasure/TreasurePieceConfig";

export class TreasureLevelConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(TreasureLevelConfig, v) : SKIP;
        }, (v) => {
            return deserialize(TreasureLevelConfig, v);
        });
    }

    constructor() {
        super();

        this._key = null;
        this._stage = 0;
        this._price = 0;
        this._winPercent = 0;
        this._winReward = null;
        this._pieces = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get stage() {
        return this._stage;
    }

    set stage(value) {
        this._stage = value;
    }

    get price() {
        return this._price;
    }

    set price(value) {
        this._price = value;
    }

    get winPercent() {
        return this._winPercent;
    }

    set winPercent(value) {
        this._winPercent = value;
    }

    get winReward() {
        return this._winReward;
    }

    set winReward(value) {
        this._winReward = value;
    }

    get pieces() {
        return this._pieces;
    }

    set pieces(value) {
        this._pieces = value;
    }

    valid() {
        if (!Number.isInteger(this.stage) || this.stage < 0) {
            return false;
        }

        if (!Number.isInteger(this.price) || this.price < 0) {
            return false;
        }

        if (!Number.isInteger(this.winPercent) || this.winPercent <= 0 || this.winPercent > 100) {
            return false;
        }

        if (this.winReward && !this.winReward.valid()) {
            return false;
        }

        if (this.pieces && this.pieces.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return   this.winPercent === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TreasureLevelConfig());
        } else if (target instanceof TreasureLevelConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TreasureLevelConfig, {
    _key: alias("key", Schema.primitive()),
    _stage: alias("stage", Schema.primitive()),
    _price: alias("price", Schema.primitive()),
    _winPercent: alias("win_percent", Schema.primitive()),
    _winReward: alias("win_reward", RewardModel.schema()),
    _pieces: alias("pieces", list(TreasurePieceConfig.schema()))
});